import React, { useState } from 'react'
import { Button, Col, Space, Form } from 'antd'
import {
  successNotification,
  carsUrl,
  postRequest
} from '../../config'
import SelectInput from 'components/Forms/SelectInput'
import BasicInput from '../../components/Forms/BasicInput'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

const CarImageForm = props => {
  const [payload, setPayload] = useState({
    active: true,
    mainImage: false,
    isShowcaseImage: false,
    isVideo: false,
    videoId: ''
  })
  const car = props.car
  const [image, setImage] = useState('')
  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleSelect = stateName => value => {
    setPayload({
      ...payload,
      [stateName]: value
    })
  }

  const handleImageChange = event => {
    setImage(event.target.files[0]) // Capture the file
  }

  const handleInputChange = stateName => event => {
    setPayload({ ...payload, [stateName]: event.target.value })
  }

  const handleSubmit = async event => {
    event.preventDefault()

    // Prepare FormData
    const formData = new FormData()
    formData.append('image', image)
    formData.append('is_showcase_image', payload.isShowcaseImage)
    formData.append('active', payload.active)
    formData.append('is_video', payload.isVideo)
    formData.append('video_id', payload.videoId)

    const response = await postRequest(
      `${carsUrl}/${car.id}/add-image`,
      formData, 'image', setLoading, false
    )
    if (response.success) {
      props.handleCancel()
      successNotification('New Image Added')
    } else {
      if (response.error.response) {
        if (response.error.response) {
          setServerErrors(response.error.response.data)
        }
      }
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Form className="p-2rem" layout="vertical">
            <div className="row">
              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Should this be used for product showcase?"
                  name="isShowcaseImage"
                  value={payload.isShowcaseImage}
                  onChange={handleSelect('isShowcaseImage')}
                  optionList={[
                    { label: 'Yes', value: true },
                    { label: 'No', value: false }
                  ]}
                  required
                />
                {serverErrors.isShowcaseImage &&
                  serverErrors.isShowcaseImage.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Is this a video file"
                  name="isVideo"
                  value={payload.isVideo}
                  onChange={handleSelect('isVideo')}
                  optionList={[
                    { label: 'Yes', value: true },
                    { label: 'No', value: false }
                  ]}
                  required
                />
                {serverErrors.isVideo &&
                  serverErrors.isVideo.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>
              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Is Active"
                  name="active"
                  value={payload.active}
                  onChange={handleSelect('active')}
                  optionList={[
                    { label: 'Yes', value: true },
                    { label: 'No', value: false }
                  ]}
                  required
                />
                {serverErrors.active &&
                  serverErrors.active.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              {payload.isVideo ? (
                <div className="col-md-5">
                  <BasicInput
                    label={'Video ID'}
                    value={payload.videoId}
                    name={'videoId'}
                    placeholder="Video ID"
                    handleChange={handleInputChange('videoId')}
                    required={true}
                  />
                  {serverErrors.videoId &&
                    serverErrors.videoId.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              ) : (
                <div
                  className="col-md-5"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    required
                  />
                  {serverErrors.image &&
                    serverErrors.image.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              )}

              {serverErrors.nonFieldErrors &&
                serverErrors.nonFieldErrors.map((err, i) => (
                  <div className="text-danger" key={i}>
                    {err}
                  </div>
                ))}

              <Col md={24}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginBottom: '20px'
                  }}
                >
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleSubmit}
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Space>
                </div>
              </Col>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

CarImageForm.propTypes = {
  car: PropTypes.object,
  handleCancel: PropTypes.func
}

export default withRouter(CarImageForm)
